import React, { useEffect, useState, useRef } from 'react';
import App from "../../App";
import { AiOutlineArrowLeft, FaPrint, FiEye } from "react-icons/all";
import { Link, withRouter, useParams, useHistory } from "react-router-dom";
import Loader from 'react-loader';
import { getData, putData } from '../../services/baseServices'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ReactToPrint from "react-to-print";
import ChallanCopy from './ChallanCopy';
import { getFormattedDate, humanize } from '../../helper/utils';
import ConfirmationModal from "../common/Modal";
import _ from 'lodash'
import { DEBOUNCE_TIME } from "../../helper/env"
import { toast } from "react-toastify";

const ForwardChallanDetails = () => {
    const [challanDetails, setChallanDetails] = useState({})
    const [loading, setLoading] = useState(false)
    const componentRef = useRef();
    const {id} = useParams();
    const [selectedPage, setSelectedPage] = useState({'1': false})
    const [selectedOrderIds, setSelectedOrderIds] = useState([])
    const [orderList, setOrderList] = useState([])
    const history = useHistory()

    const getChallan = () => {
      getData(`challans/${id}`)
      .then(res => {
        setChallanDetails(res?.data)
        setOrderList(res?.data?.challan_line_items)
        setLoading(false)
      })
      .catch(errMsg => {
        console.log('Error Message: ', errMsg)
        setLoading(false)
      });
    }
  
    useEffect (() =>{
        setLoading(true)
        getChallan()
    }, [])

    const setMark = (all) => {
      if(all) {
        setSelectedPage({...selectedPage,  [1]: true})
        const xxx = orderList?.filter(i => i.status !== 'received_by_dh')?.map(item=>+item?.order?.id)
        let ids = [...selectedOrderIds]
        ids = ids?.filter(i => !xxx.includes(i))
        ids = ids.concat(xxx)
        setSelectedOrderIds(ids)
      } else {
        setSelectedPage({...selectedPage,  [1]: false})
        let selectedIds = [...selectedOrderIds]
        const orderIds = orderList?.filter(i => i.status !== 'received_by_dh')?.map(i => i?.order?.id)
        selectedIds = selectedIds?.filter(i => !orderIds.includes(i))
        setSelectedOrderIds(selectedIds)
      }
    }

    const selectOrder = (orderId) => {
      let ids = [...selectedOrderIds];
      if (ids?.includes(orderId)) {
        ids = ids.filter(function (e) {
          return e != orderId
        });
      } else {
        ids.push(+orderId);
          
      }
      setSelectedOrderIds(ids)
    }
  
    const submitChallanForm = () => {
      const params = {
          order_ids: selectedOrderIds
      }
      putData(`challans/${challanDetails?.id}/received`,params)
      .then(res => {
        if(res.success) {
          history.go(0)
          toast.success("Challan has been received successfully.");
        }
        else {
          toast.error(res.message);
        }
      })
      .catch(errMsg => {
        toast.error(errMsg);
      }); 
  }

  const debouncedOnSubmitChallan = _.debounce(()=>{
    submitChallanForm()
  }, DEBOUNCE_TIME);

  const handleWithDebounceSubmitForm = () => {
    debouncedOnSubmitChallan();
  } 
      return (
        <App layout="">
          <div className="page-header">
            <h2 className="page-title">Challan Details</h2>
            <div className="ml-auto">
              <Link to="/challan/list"
                    className="btn btn-sm btn-link mr-2"><AiOutlineArrowLeft/> Back to List</Link>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <ReactToPrint
              trigger={() => {
                return (<a href="#">
                  <Button variant={"default"}  size={"sm"} className='mb-2'><FaPrint/> Print Challan
                  </Button>
                </a>)
              }}
              content={() => componentRef.current}
            />
          </div>
          
          <div ref={componentRef}>
            <ChallanCopy 
              orderItems={challanDetails?.challan_line_items || []}
              from={challanDetails?.fulfillment_center} 
              to={challanDetails?.distributor}/>
          </div>
            
          <div className="main-content">
              <Loader loaded={!loading}>
                  <div className="card-block">
                      <div className="block-body">
                          <table className="info-table">
                              <tbody>
                                <tr>
                                    <td style={{width: '200px'}}>Challan No</td>
                                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                    <td className={`text-bold`}>{challanDetails?.id}</td>
                                </tr>
                                <tr>
                                    <td style={{width: '200px'}}>Status</td>
                                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                    <td>{humanize(challanDetails?.status)}</td>
                                </tr>
                                <tr>
                                    <td style={{width: '200px'}}>Created Date</td>
                                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                    <td>{getFormattedDate(challanDetails?.created_at, 'DD-MM-YYYY')}</td>
                                </tr>
                                <tr>
                                    <td style={{width: '200px'}}>Total Orders</td>
                                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                    <td>{orderList?.length}</td>
                                </tr>
                                {
                                <tr>
                                    <td style={{width: '200px'}}>Received Orders</td>
                                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                    <td>{orderList?.filter(i => i.status === 'received_by_dh')?.length}</td>
                                </tr>
                                }
                              </tbody>
                          </table>
                          {
                            
                            <div className="block-body d-flex justify-content-between">
                                {
                                  (selectedOrderIds?.length > 0 &&  ['in_transit_to_dh', 'partially_received'].includes(challanDetails?.status)) &&
                                  <>
                                    <div>
                                        Selected Orders: <strong>{selectedOrderIds?.length}</strong>
                                        <br/>
                                    </div>
                                    <div>
                                      <OverlayTrigger
                                          key="view"
                                          placement="top"
                                          overlay={
                                          <Tooltip id={`tooltip-view`}>Receive Challan</Tooltip>
                                          }
                                      >
                                          <ConfirmationModal 
                                              customBtn = {true}
                                              btnText = "Receive Challan"
                                              variant = "primary"
                                              title="Receive Challan" 
                                              body="Are you sure to receive the challan?" 
                                              handleAction={() =>handleWithDebounceSubmitForm()}/>
                                      </OverlayTrigger>
                                  </div>
                                  </>
                                }
                                
                            </div>
                        }
                        
                          <h6 className='mt-3'>Order List</h6>
                          <table className="order-table table table-striped">
                            <thead>
                              <tr>
                                <th>
                                  {
                                  !selectedPage?.[1] ?
                                  <span><input name="select-all" id="select-all" type="checkbox" disabled={challanDetails?.status === 'completed' || orderList?.length == 0 || challanDetails?.status === 'initiated'} onChange={()=>setMark(true)}/>  Select All</span>
                                  : <span><input name="unselect-all" type="checkbox" id="unselect-all" checked={true} onChange={()=> setMark(false)}/>  Unselect All</span>
                                  }
                                </th>
                                <th>Order Id</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Shipping Type</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                challanDetails?.challan_line_items?.map((lineItem, index)=>{
                                  return(
                                    <tr key={index}>
                                      <td>
                                      <input 
                                          custom
                                          inline
                                          disabled={lineItem?.status === 'received_by_dh' || challanDetails?.status === 'initiated'}
                                          type="checkbox" 
                                          id={`custom_checkbox_${index}`} 
                                          className="input"
                                          value={lineItem?.order?.id} 
                                          name="select_order" 
                                          checked={selectedOrderIds?.includes((lineItem?.order?.id)) || lineItem?.status === 'received_by_dh'}
                                          onChange={()=>selectOrder(lineItem?.order?.id)}/>
                                      </td>
                                      <td>{lineItem?.order?.id}</td>
                                      <td>{lineItem?.order?.total_price}</td>
                                      <td>{humanize(lineItem?.order?.status)}</td>
                                      <td>{lineItem?.order?.shipping_type}</td>
                                      <td>
                                        
                                        <div className="btn-group">
                                          <OverlayTrigger
                                            key="view"
                                            placement="top"
                                            overlay={
                                              <Tooltip id={`tooltip-view`}>View</Tooltip>
                                            }
                                          >
                                            <Link
                                              to={`${process.env.PUBLIC_URL}/customerOrder/details/${lineItem?.order?.id}`}
                                              className="btn btn-sm btn-default"
                                            >
                                              <FiEye />
                                            </Link>
                                          </OverlayTrigger>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                })
                              }
                            </tbody>
                          </table>
                      </div>
                  </div>
              </Loader>
          </div>
        </App>
      );
    }
  
  export default withRouter(ForwardChallanDetails);
